import classNames from 'classnames'
import React, { Children, cloneElement, isValidElement, memo, useRef } from 'react'

import type { SliderProps } from './types'
import useStyles from './useStyles'
import useUpdateXPosition from './useUpdateXPosition'

function Slider({
  className,
  centerMode = false,
  children,
  currentSlideIndex = 0,
  gap = '0.5rem',
  itemWidth = 100,
  minMoveOffset = 70,
  onChange,
}: SliderProps) {
  const ulRef = useRef<HTMLUListElement>(null)
  const classes = useStyles({ gap, itemWidth })
  const childrenWithProps = Children.map(children, child =>
    isValidElement(child) ? cloneElement(child, { gap, itemWidth }) : child,
  )
  const itemsCount = Children.count(children)

  useUpdateXPosition({
    centerMode,
    currentSlideIndex,
    itemsCount,
    itemWidth,
    minMoveOffset,
    onChange,
    ulRef,
  })

  return (
    <div className={classNames(classes.root, className)}>
      <ul className={classes.ul} ref={ulRef}>
        {childrenWithProps}
      </ul>
    </div>
  )
}

export default memo(Slider)
